import { ActorProvider } from "@src/providers/actorProvider";
import { Outlet } from "react-router-dom";

export default function AuthenticatedLayout() {
  return (
    <ActorProvider>
      <Outlet />
    </ActorProvider>
  );
}
